import * as React from "react";
import radium from "radium";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import DotLoader from "backpack-ui/dist/components/dotLoader";
import { FlightQuoteFetcher, NoFlightResults, FlightSearchWidget } from "backpack-ui/dist/components/flightSearchWidget/";
import { textBodyArticle, textBodyArticleSmall } from "backpack-ui/dist/utils/typography";
import { fontSizeHeading4 } from "backpack-ui/dist/styles/typography";
import { Heading } from "backpack-ui/dist/components/text";
import mq from "backpack-ui/dist/styles/mq";
import PropTypes from "prop-types";

const styles = {
  container: {
    marginBottom: "32px",
    marginTop: "32px",

    [`@media (min-width: ${mq.min["960"]})`]: {
      marginBottom: "64px",
      marginTop: "64px",
    },
  },

  title: {
    marginBottom: "10px",

    [`@media (min-width: ${mq.min["960"]})`]: {
      fontSize: `${fontSizeHeading4}px`,
    },
  },

  text: {
    ...textBodyArticleSmall(),
    marginBottom: "32px",
    width: "100%",
    [`@media (min-width: ${mq.min["960"]})`]: {
      ...textBodyArticle(),
      marginBottom: "80px",
      width: "85%",
    },
  },
  loadingContainer: {
    textAlign: "center",
    backgroundColor: "#f6f6f6",
    height: "295px",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    display: "flex",
  },
  loadText: {
    fontSize: "12px",
  },
};


const FlightQuote = ({ place }) => (
  <FlightQuoteFetcher
    destination={place}
    render={({ loading, currency, destination, foundResults, quote }) => (
      <div className="FlightQuote" style={styles.container}>
        {!loading && !foundResults &&
          <NoFlightResults
            link={quote && quote.referral}
            destinationName={destination && destination.name}
          />
        }
        {!loading && quote && foundResults &&
          <ReactCSSTransitionGroup
            transitionName="fadeIn"
            transitionAppear
            transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            <div key="flights-widget">
              <Heading
                level={2}
                size={6}
                weight="medium"
                style={styles.title}
              >
                Flights to {destination.name}
              </Heading>

              <p style={styles.text}>
                {/* eslint-disable max-len */}
                Ready to make it happen? Search for the best deals on flights to {destination.name} now.
              </p>

              <FlightSearchWidget
                depart={{
                  airportCode: quote.outboundLeg.destination.airportCode,
                  city: quote.outboundLeg.destination.city,
                }}
                arrive={{
                  airportCode: quote.outboundLeg.origin.airportCode,
                  city: quote.outboundLeg.origin.city,
                }}
                price={{
                  amount: quote.minPrice,
                  currency,
                }}
                onClick={() => window.open(quote.referral)}
              />
            </div>
          </ReactCSSTransitionGroup>
        }
        <ReactCSSTransitionGroup
          transitionName="fadeIn"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          <div key="flights-loading">
            {loading &&
              <div style={styles.loadingContainer} >
                <p style={styles.loadText}>Checking flights...</p>
                <DotLoader />
              </div>
            }
          </div>
        </ReactCSSTransitionGroup>
      </div>
    )}
  />
);

FlightQuote.propTypes = {
  place: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string,
  }),
};


export default radium(FlightQuote);



// WEBPACK FOOTER //
// ./assets/pois/components/flightQuote/index.jsx